<template>
  <div>
    <div class="modal fade" id="mod-add-product-bundle" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] min-h-screen"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <div class="mb-[16px]">
              <h4
                class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[5px]"
              >
                Create New Product Bundle
              </h4>
            </div>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Bundle Name</label
              >
              <div>
                <input
                  :class="[{ 'is-invalid': v1.name }]"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Enter bundle name"
                  type="text"
                  v-model="createProductBundle.name"
                />
                <div v-if="v1.name" class="parsley-errors-list filled">
                  <p class="text-danger error-text ">Enter a valid name.</p>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Categories</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  v-model="createProductBundle.categoryId"
                >
                  <option :value="null" disabled selected
                    >Select a Category</option
                  >
                  <option
                    v-for="option in categoryList"
                    :key="option.id"
                    :value="option.id"
                    >{{ option.name }}</option
                  >
                </select>
                <div v-if="v1.categoryId" class="parsley-errors-list filled">
                  <p class="text-danger error-text ">Enter a valid name.</p>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >PB Code</label
              >
              <div
                class="flex flex-col items-center gap-[10px] w-full relative"
              >
                <div class="relative w-full">
                  <input
                    :class="[{ 'is-invalid': v1.code }]"
                    type="text"
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none pr-[40px]"
                    v-model="createProductBundle.code"
                    placeholder="Enter bundle code"
                    @blur="
                      validateProductCode(
                        createProductBundle.code,
                        user.parentId
                      )
                    "
                  />
                  <i
                    v-if="isProductValid === true"
                    class="fa fa-times text-danger absolute right-[12px] top-1/2 transform -translate-y-1/2"
                  ></i>
                  <i
                    v-if="isProductValid === false"
                    class="fa fa-check text-success absolute right-[12px] top-1/2 transform -translate-y-1/2"
                  ></i>
                </div>
                <span
                  v-if="isProductValid === true"
                  class="text-danger error-text mt-[4px]"
                >
                  Product code already exists
                </span>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Description</label
              >
              <div>
                <textarea
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none pr-[40px]"
                  v-model="createProductBundle.description"
                  placeholder="Enter bundle description"
                ></textarea>
                <div v-if="v1.description" class="parsley-errors-list filled">
                  <p class="text-danger error-text ">
                    Enter a valid Description.
                  </p>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <div class="flex flex-col gap-1 w-full">
                <div
                  v-for="(input, index) in createProductBundle.products"
                  :key="`input-${index}`"
                  class="flex items-center justify-between"
                >
                  <div class="w-[60%]">
                    <label
                      class="text-[#353535] font-medium text-[14px] leading-[20px]"
                      >Select Products</label
                    >
                    <select
                      class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                      v-model="input.productId"
                      @change="getProductprice(input.productId)"
                    >
                      <option value="" selected disabled>Select Product</option>
                      <option
                        v-for="option in availableProducts(index)"
                        :key="option.id"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                  <div class="w-[33%]">
                    <label
                      class="text-[#353535] font-medium text-[14px] leading-[20px]"
                      >Quantity</label
                    >
                    <input
                      class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                      placeholder="Enter Quantity"
                      type="number"
                      v-model.number="input.quantity"
                    />
                  </div>
                  <div
                    v-if="createProductBundle.products.length > 1"
                    class="flex items-center"
                  >
                    <span
                      @click="deleteProductList('createProductBundle', index)"
                      class="mdi mdi-close text-red-500 cursor-pointer"
                    ></span>
                  </div>
                </div>
                <span
                  class="text-[#2463EB] text-[14px] font-medium leading-[20px] cursor-pointer"
                  @click.prevent="addFields()"
                >
                  <i class="fa fa-plus"></i>
                  <span> Add another product to bundle</span>
                </span>
              </div>
            </div>

            <div class="pb-[16px] ">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Unit</label
              >
              <div class="flex flex-col w-full">
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none pr-[40px]"
                  v-model="createProductBundle.unit"
                >
                  <option :value="null" disabled selected>Select a unit</option>
                  <option
                    v-for="unit in units"
                    :key="unit.name"
                    :value="unit.name"
                  >
                    {{ unit.name }}
                  </option>
                </select>
                <div v-if="v1.unit" class="parsley-errors-list filled">
                  <p class="text-danger error-text ">Required</p>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Add Retail Price</label
              >
              <div class="flex flex-col w-full">
                <input
                  :class="[{ 'is-invalid': v1.retailPrice }]"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none pr-[40px]"
                  placeholder="Enter Retail Price"
                  type="text"
                  v-model="createProductBundle.retailPrice"
                />
                <div v-if="v1.retailPrice" class="parsley-errors-list filled">
                  <p class="text-danger error-text ">
                    Enter a retail price.
                  </p>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                v-if="!previewUrl"
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Upload product image</label
              >
              <input
                id="file"
                type="file"
                class="custom-file-input"
                @change="uploadFile"
                ref="file"
                hidden
              />
              <div class="flex flex-col items-center" v-if="previewUrl">
                <div>
                  <img
                    class="image-preview"
                    :src="previewUrl"
                    alt="logo"
                    width="40"
                    height="40"
                  />
                </div>
                <button
                  class="p-[8px] border-[1.5px] border-[#DC2828] border-solid text-[#DC2828] text-[14px] leading-[20px] rounded-[8px] mt-[6px] mb-[16px]"
                  @click="cancelUpload"
                >
                  Delete image
                </button>
              </div>
              <div
                @click="onPickFile"
                v-else
                class="border py-[12px] px-[14px] w-full rounded-[8px] flex justify-between items-center"
              >
                <p
                  class="text-[#96A0B5] font-normal text-[14px] leading-[28px]"
                >
                  select image(max.1mb)
                </p>
                <span class="">
                  <img
                    src="/assets/img/document-upload.svg"
                    alt=""
                    class="w-[20px] h-[20px]"
                  />
                </span>
              </div>
            </div>
            <div class="pb-[10px]">
              <div>
                <label
                  class="custom-control custom-checkbox custom-control-inline"
                >
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    v-model="createProductBundle.active"
                  />
                  <span class="custom-control-label"
                    >This product is active</span
                  >
                </label>
              </div>
            </div>
            <div class="pb-[10px]">
              <div>
                <label
                  class="custom-control custom-checkbox custom-control-inline"
                >
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    v-model="createProductBundle.availability"
                    false-value="0"
                    true-value="1"
                  />
                  <span class="custom-control-label"
                    >This product is available for sale</span
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
              @click="cancelUpload"
            >
              Cancel
            </button>
            <button
              :disabled="isBusy || isProductValid == true"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="createMyProductBundle"
            >
              {{ isBusy ? "Busy..." : "Add Product Bundle" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Select2 from "@/components/Select2";
import { bus } from "../../main";

export default {
  name: "ProductsBundle",
  components: {
    Select2,
  },
  data() {
    return {
      createProductBundle: {
        name: "",
        code: "",
        description: "",
        products: [{}],
        retailPrice: "",
        reOrderLevel: 0,
        availability: 0,
        image: null,
        active: false,
        categoryId: null,
        units: null,
      },
      v1: {
        name: false,
        code: false,
        description: false,
        retailPrice: false,
        reOrderLevel: false,
        availability: false,
        units: null,
        active: false,
      },
      v2: {
        name: false,
        code: false,
        description: false,
        retailPrice: false,
        reOrderLevel: false,
        availability: false,
        units: null,
        active: false,
      },
      units: [],
      previewUrl: "",
      products: [],
      categoryList: [],
      isProductValid: null,
      productsItem: [],
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  created() {
    this.getUnits();
    this.getTypes();
    this.getProducts();
    this.getCategories();
    bus.$on("viewAdds", this.viewAdd);
  },
  methods: {
    viewAdd() {
      $("#mod-add-product-bundle").modal("show");
      this.previewUrl = "";
      this.createProductBundle.image = null;
    },
    availableProducts(currentIndex) {
      const selectedIds = this.createProductBundle.products
        .filter((_, index) => index !== currentIndex)
        .map((product) => product.productId)
        .filter((id) => id);
      return this.products.filter(
        (product) => !selectedIds.includes(product.id)
      );
    },
    getProductprice(val) {
      if (!val) return;
      const product = this.products.find((x) => x.id == val);
      if (!product) return;
      let productCost = product.retailPrice;
      let productName = product.name;
      this.productsItem.push({ name: productName, cost: productCost });
    },

    deleteProductList(mode, index) {
      if (
        this.createProductBundle.products.length > 1 &&
        mode == "createProductBundle"
      ) {
        this.createProductBundle.products.splice(index, 1);
      }
    },
    confirmModal() {
      $("#mod-confirm").modal("show");
    },
    addFields() {
      this.createProductBundle.products.push({ productId: "", quantity: 0 });
    },
    removeFields(index, products) {
      products.splice(index, 1);
    },
    onPickFile() {
      this.$nextTick(() => {
        if (this.$refs.file) {
          this.$refs.file.click();
        }
      });
    },
    cancelUpload() {
      this.createProductBundle = {
        name: "",
        code: "",
        description: "",
        products: [{ productId: "", quantity: 0 }],
        retailPrice: "",
        reOrderLevel: 0,
        availability: 0,
        image: null,
        active: false,
        categoryId: null,
        unit: null,
      };
      this.previewUrl = "";
      this.productsItem = [];
      this.isProductValid = null;
      this.v1 = {
        name: false,
        code: false,
        description: false,
        retailPrice: false,
        reOrderLevel: false,
        availability: false,
        unit: false,
        active: false,
      };
      $("#mod-add-product-bundle").modal("hide");
      this.createProductBundle.image = null;
    },
    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    uploadFile() {
      this.createProductBundle.image = this.$refs.file.files[0];
      this.previewUrl = URL.createObjectURL(this.createProductBundle.image);
    },
    async validateProductCode(code, parentId) {
      this.isBusy = true;
      try {
        const response = await this.$http.get(
          `/Products/distributorCodeExist/${parentId}/${code}`
        );
        if (response.ok) {
          this.isBusy = false;
          this.isProductValid = response.data;
          return;
        }
      } catch (err) {
        this.$toast.info(err, {
          icon: true,
          rtl: false,
        });
      }
    },

    getUnits() {
      var t = "Product Unit";
      var a = true;

      this.$http
        .get(
          "/Categories/getListNoPaggingForDistributor?type=" +
            t +
            "&active=" +
            a +
            (this.user.parentId
              ? "&parentId=" + this.user.parentId
              : "Product Category")
        )
        .then(function(res) {
          this.units = res.body;
        })
        .catch(function() {});
    },

    async getProducts() {
      this.isBusy = true;
      await this.$http
        .get(
          "/Products/getListNoPagingForDistributor?" +
            (this.user.parentId ? "parentId=" + this.user.parentId : "") +
            "&active=true"
        )
        .then(function(res) {
          this.products = res.body;
          this.isBusy = false;
        })
        .catch(function() {});

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    getTypes() {
      this.types = ["Finite", "Infinite"];
    },

    getCategories() {
      var t = "Product Category";
      this.$http
        .get(
          "/Categories/getListNoPaggingForDistributor?type=" +
            t +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            "&active=true"
        )
        .then(function(res) {
          this.categoryList = res.body;
        })
        .catch(function() {});
    },
    async createMyProductBundle() {
      this.isBusy = true;
      const formData = new FormData();
      formData.append("name", this.createProductBundle.name);
      formData.append("code", this.createProductBundle.code);
      formData.append("Description", this.createProductBundle.description);
      for (let i = 0; i < this.createProductBundle.products.length; i++) {
        formData.append(
          `products[${i}].productId`,
          this.createProductBundle.products[i].productId
        );
        formData.append(
          `products[${i}].quantity`,
          this.createProductBundle.products[i].quantity
        );
      }
      formData.append("RetailPrice", this.createProductBundle.retailPrice);
      formData.append("ReOrderLevel", this.createProductBundle.reOrderLevel);
      formData.append("Active", this.createProductBundle.active);
      formData.append("unit", this.createProductBundle.unit);
      formData.append("categoryId", this.createProductBundle.categoryId);
      formData.append(
        "SaleStatus",
        Number(this.createProductBundle.availability)
      );
      formData.append("Image", this.createProductBundle.image);
      if (this.validateProductBundle(this.createProductBundle)) {
        try {
          const response = await this.$http.post("/ProductBundle", formData);

          if (response.ok) {
            this.$toast.success("Product bundle created successfully", {
              icon: true,
              rtl: false,
            });
            this.isBusy = false;
            this.cancelUpload();
            this.updateState(this.createProductBundle);
            $("#mod-add-product-bundle").modal("hide");
            $("#mod-confirm").modal("hide");
          } else {
            this.$toast.error("Failed to create product bundle", {
              icon: true,
              rtl: false,
            });
            this.isBusy = false;
          }
        } catch (err) {
          let errorMessage =
            "An error occurred while creating the product bundle";
          if (err.response && err.response.data && err.response.data.message) {
            errorMessage = err.response.data.message;
          } else if (typeof err === "string") {
            errorMessage = err;
          }

          this.$toast.error(errorMessage, {
            icon: true,
            rtl: false,
          });
          this.isBusy = false;
        }
      } else {
        this.$toast.warning("Please fill all required fields correctly", {
          icon: true,
          rtl: false,
        });
        this.isBusy = false;
      }
    },
    validateProductBundle(formType) {
      this.v1 = {
        name: false,
        code: false,
        description: false,
        productUnit: false,
        retailPrice: false,
        reOrderLevel: false,
        unit: false,
        active: false,
      };
      var isValid = true;
      if (!formType.name) {
        this.v1.name = true;
        isValid = false;
        this.isBusy = true;
      }

      if (!formType.code) {
        this.v1.code = true;
        isValid = false;
        this.isBusy = true;
      }

      if (!formType.description) {
        this.v1.description = true;
        isValid = false;
        this.isBusy = true;
      }
      if (!formType.unit) {
        this.v1.unit = true;
        isValid = false;
        this.isBusy = true;
      }
      if (!formType.retailPrice) {
        this.v1.retailPrice = true;
        isValid = false;
        this.isBusy = true;
      }

      if (Number(formType.reOrderLevel) < 0) {
        this.v1.reOrderLevel = true;
        isValid = false;
        this.isBusy = true;
      }

      if (!formType.active) {
        this.v1.active = true;
        isValid = false;
        this.isBusy = true;
      }

      return isValid;
    },

    updateState(formType) {
      (formType.name = null),
        (formType.code = null),
        (formType.description = null),
        (formType.products = [{ product: null, quantity: 0 }]),
        (formType.additionalCost = null),
        // (formType.productUnit = 0),
        (formType.categoryId = null),
        (formType.retailPrice = null),
        (formType.reOrderLevel = 0),
        (formType.active = false);
      formType.image = false;
    },
  },
};
</script>
